var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#FE0000",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 30H62V28C62 26.4087 61.3679 24.8826 60.2426 23.7574C59.1174 22.6321 57.5913 22 56 22H44C42.4087 22 40.8826 22.6321 39.7574 23.7574C38.6321 24.8826 38 26.4087 38 28V30H28C27.4696 30 26.9609 30.2107 26.5858 30.5858C26.2107 30.9609 26 31.4696 26 32C26 32.5304 26.2107 33.0391 26.5858 33.4142C26.9609 33.7893 27.4696 34 28 34H30V70C30 71.0609 30.4214 72.0783 31.1716 72.8284C31.9217 73.5786 32.9391 74 34 74H66C67.0609 74 68.0783 73.5786 68.8284 72.8284C69.5786 72.0783 70 71.0609 70 70V34H72C72.5304 34 73.0391 33.7893 73.4142 33.4142C73.7893 33.0391 74 32.5304 74 32C74 31.4696 73.7893 30.9609 73.4142 30.5858C73.0391 30.2107 72.5304 30 72 30ZM46 60C46 60.5304 45.7893 61.0391 45.4142 61.4142C45.0391 61.7893 44.5304 62 44 62C43.4696 62 42.9609 61.7893 42.5858 61.4142C42.2107 61.0391 42 60.5304 42 60V44C42 43.4696 42.2107 42.9609 42.5858 42.5858C42.9609 42.2107 43.4696 42 44 42C44.5304 42 45.0391 42.2107 45.4142 42.5858C45.7893 42.9609 46 43.4696 46 44V60ZM58 60C58 60.5304 57.7893 61.0391 57.4142 61.4142C57.0391 61.7893 56.5304 62 56 62C55.4696 62 54.9609 61.7893 54.5858 61.4142C54.2107 61.0391 54 60.5304 54 60V44C54 43.4696 54.2107 42.9609 54.5858 42.5858C54.9609 42.2107 55.4696 42 56 42C56.5304 42 57.0391 42.2107 57.4142 42.5858C57.7893 42.9609 58 43.4696 58 44V60ZM58 30H42V28C42 27.4696 42.2107 26.9609 42.5858 26.5858C42.9609 26.2107 43.4696 26 44 26H56C56.5304 26 57.0391 26.2107 57.4142 26.5858C57.7893 26.9609 58 27.4696 58 28V30Z",
    fill: "#FE0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.5efe52b819f827fd24adc993d89008d7.svg";
export { ForwardRef as ReactComponent };